import {computed, observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";

export default class TempoMedioPreenchimentoVagaStore {
    @observable erro;
    @observable carregando;
    @observable dados;

    constructor() {
        this.indicadorService = new IndicadorService();
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findTempoMedioPreenchimentoVaga(filtro).then(response => {
            const fornecedoresAgrupados = _.groupBy(response.data, (d) => d.fornecedor);
            const fornecedores = Object.keys(fornecedoresAgrupados);
            const empresasGloboAgrupadas = _.groupBy(response.data, (d) => d.empresaGlobo);
            const empresasGlobo = Object.keys(empresasGloboAgrupadas);

            let dados = [];
            _.forEach(fornecedores, (fornecedor) => {
                let dado = { nome: fornecedor };

                const fornecedoresEmpresasGlobo = fornecedoresAgrupados[fornecedor];

                _.forEach(fornecedoresEmpresasGlobo, (fornecedorEmpresaGlobo) => {
                    dado = { ...dado, [fornecedorEmpresaGlobo.empresaGlobo]: fornecedorEmpresaGlobo.tempoMedio };
                });

                dados = [ ...dados, dado ];
            });

            this.empresasGlobo = empresasGlobo;
            this.dados = dados;
            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }
}
